import React from "react";
import { Card, Divider, Stack, TextField, Typography } from "@mui/material";

/**
 * Voucher print header/footer — same UX and validation rules as ticket tab (lines, limits).
 */
const AccessSystemVoucherSettingsTab = ({
  values,
  errors,
  setFieldValue,
  handleBlur,
  linesHelp,
  t,
}) => (
  <Card sx={{ p: 2 }}>
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight={700}>
        {t("pages.accessSystemSettings.printSettings.title", {
          defaultValue: "Nastavenie tlače",
        })}
      </Typography>
      <Divider />

      <TextField
        fullWidth
        multiline
        minRows={4}
        name="voucherHeaderText"
        value={values.voucherHeaderText}
        onChange={(e) => setFieldValue("voucherHeaderText", e.target.value)}
        onBlur={handleBlur}
        label={t("pages.accessSystemSettings.printSettings.headerLinesVoucher", {
          defaultValue: "Text pred poukážkou",
        })}
        helperText={errors.voucherHeaderText ? errors.voucherHeaderText : linesHelp}
        error={Boolean(errors.voucherHeaderText)}
      />

      <TextField
        fullWidth
        multiline
        minRows={4}
        name="voucherFooterText"
        value={values.voucherFooterText}
        onChange={(e) => setFieldValue("voucherFooterText", e.target.value)}
        onBlur={handleBlur}
        label={t("pages.accessSystemSettings.printSettings.footerLinesVoucher", {
          defaultValue: "Text za poukážkou",
        })}
        helperText={errors.voucherFooterText ? errors.voucherFooterText : linesHelp}
        error={Boolean(errors.voucherFooterText)}
      />
    </Stack>
  </Card>
);

export default AccessSystemVoucherSettingsTab;
